import { PriceType, SearchResponse } from "interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const priceTypeApi = coreApi.injectEndpoints({
  endpoints: builder => ({
    getPriceType: builder.query<Array<PriceType>, void>({
      query: () => ({ url: "PriceType/Get", method: "GET" }),
      transformResponse: (response: SearchResponse<PriceType>) => response.items,
      providesTags: [{ type: "PriceType" as const, id: "LIST" }],
    }),

    addPriceType: builder.mutation<void, Partial<PriceType>>({
      query: body => ({
        url: "PriceType/Post",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "PriceType", id: "LIST" }],
    }),

    updatePriceType: builder.mutation<void, Partial<PriceType>>({
      query: body => ({
        url: "PriceType/Put",
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "PriceType", id: "LIST" }],
    }),

    deletePriceType: builder.mutation<void, number>({
      query: id => ({
        url: `PriceType/Delete`,
        method: "DELETE",
        params: { id },
      }),
      invalidatesTags: [{ type: "PriceType", id: "LIST" }],
    }),

    searchPriceType: builder.query<SearchResponse<PriceType>, { skip: number; take: number; query?: string }>({
      query: ({ skip, take, query }) => ({
        url: "PriceType/Get",
        method: "GET",
        params: { skip, take, search: query },
      }),
      providesTags: [{ type: "PriceType", id: "LIST" }],
    }),
  }),
})

export const {
  useGetPriceTypeQuery,
  useAddPriceTypeMutation,
  useUpdatePriceTypeMutation,
  useDeletePriceTypeMutation,
  useSearchPriceTypeQuery,
} = priceTypeApi
